export default __webpack_public_path__ + "static/media/icon2.26270874.png";